import { Component } from '@angular/core';

@Component({
  selector: 'r2e-horizontal-logo',
  templateUrl: './horizontal-logo.component.svg',
  styleUrl: './logo.component.scss'
})
export class HorizontalLogoComponent {}
